import { render } from "./FormatFilter.vue?vue&type=template&id=4b4c5fc2&ts=true"
import script from "./FormatFilter.ts?vue&type=script&lang=ts&external"
export * from "./FormatFilter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__